import * as types from './types';

export const getDishCategories = payload => ({
  type: types.DISH_CATEGORY_GET_REQUEST,
  payload,
});

export const getByIdRequest = payload => ({
  type: types.DISH_CATEGORY_GET_BY_ID_REQUEST,
  payload,
});

export const updateOrCreateRequest = payload => ({
  type: types.DISH_CATEGORY_CREATE_OR_UPDATE_REQUEST,
  payload,
});

export const changeFormStep = payload => ({
  type: types.CHANGE_DISH_CATEGORY_FORM_STEP,
  payload,
});

export const deleteDishCategory = payload => ({
  type: types.DISH_CATEGORY_DELETE_REQUEST,
  payload,
});

export const resetListData = () => ({
  type: types.RESET_DISH_CATEGORY_LIST_DATA,
});

export const resetErrors = () => ({
  type: types.DISH_CATEGORY_CREATE_OR_UPDATE_FAILURE,
  payload: null,
});

export const changeDishCategoryPosition = payload => ({
  type: types.DISH_CATEGORY_CHANGE_POSITION_REQUEST,
  payload,
});
